import { render, staticRenderFns } from "./limit.vue?vue&type=template&id=07be4056&"
import script from "./limit.vue?vue&type=script&lang=js&"
export * from "./limit.vue?vue&type=script&lang=js&"
import style0 from "./limit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports